import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'serviceManagementExperience.list'

const ServiceManagementServiceListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ServiceManagementServiceListSlice
